import { Linking, Platform } from 'react-native';
import Share from './packages/rnShare';
export const isAppInstalledIOS = async (iosUriScheme) => {
    try {
        if (Platform.OS === 'ios' && iosUriScheme) {
            const canOpen = await Linking.canOpenURL(`${iosUriScheme}://test`);
            return canOpen;
        }
        return false;
    }
    catch {
        return false;
    }
};
export const isAppInstalledAndroid = async (androidPackageName) => {
    try {
        if (Platform.OS === 'android' && androidPackageName) {
            const canOpen = await Share.isPackageInstalled(androidPackageName);
            return canOpen.isInstalled;
        }
        return false;
    }
    catch {
        return false;
    }
};
